/* oxlint-disable jsx-a11y/no-static-element-interactions -- collapsible header is a div; converting to <button> is a styling change */
/* oxlint-disable jsx-a11y/click-events-have-key-events -- needs a real keyboard handler; tracked as a11y debt */
import { useState } from 'react';
import { Collapse as BSCollapse, Glyphicon } from 'react-bootstrap';
import Tooltip from 'components/tooltip/Tooltip';
import ToggleButton from 'components/button/ToggleButton';
import { CollapseStyled, LabelInfoTooltip } from './Collapse.styles';
import { CollapseProps } from './Collapse.types';

const Collapse = ({
  children,
  defaultExpanded,
  label,
  variant,
  buttons,
  labelInfoTooltip,
  ...props
}: CollapseProps) => {
  const [isExpanded, setExpanded] = useState(
    defaultExpanded !== undefined ? defaultExpanded : false,
  );

  const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if ((e.target as HTMLElement).closest('.collapsible-header-buttons')) {
      return;
    }

    setExpanded((currentIsExpanded) => !currentIsExpanded);
  };

  return (
    <CollapseStyled
      $isExpanded={isExpanded}
      $variant={variant ?? 'unstyled'}
      {...props}
    >
      <div
        className="collapsible-header"
        data-testid="collapse-header"
        onClick={handleOnClick}
      >
        <div className="collapsible-header-label">
          {label}
          {labelInfoTooltip && (
            <LabelInfoTooltip data-testid="collapse-label-info-tooltip">
              <Tooltip id="collapse-label-info-tooltip" text={labelInfoTooltip}>
                <Glyphicon
                  glyph="info-sign"
                  id="collapse-label-info-tooltip-icon"
                  data-testid="collapse-label-info-tooltip-icon"
                />
              </Tooltip>
            </LabelInfoTooltip>
          )}
        </div>
        {buttons && <div className="collapsible-header-buttons">{buttons}</div>}
        <ToggleButton isExpanded={isExpanded} toggleVertically />
      </div>
      <BSCollapse in={isExpanded}>
        <div className="collapsible-body" data-testid="collapse-body">
          {children}
        </div>
      </BSCollapse>
    </CollapseStyled>
  );
};

Collapse.defaultProps = {
  defaultExpanded: undefined,
  label: undefined,
  variant: undefined,
};

export default Collapse;
